// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" opacity=\"1\"> <path d=\"M10.0001 2L18.0001 18L10.0001 15.9798L2.00009 18L10.0001 2Z\"/> </svg>";
// Exports
module.exports = code;